/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {
  getUsersData,
  addUserData,
  editUserData,
  deleteUserData,
  getRolesApi,
  getPermissionList,
  EditPermission,
  getPermissionListChildren,
  getExcel,
  getExcelPermission,
  updateRole,
  deleteRole, addRole, updateRole2
} from '../../api/users'

export default {

  FETCH_PERMISSIONS_LIST({commit}, data) {
    return new Promise((resolve, reject) => {
      getPermissionList(data.id, data.page_size).then(res => {
        commit('SET_PERMISSION_LIST', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_DATA_FOR_EXCEL_PERMISSION({commit}, a) {
    return new Promise((resolve, reject) => {
      getExcelPermission(a)
        .then((res) => {
          // commit("SET_ACTIVITY_DATA_FOR_EXCEL", res.data.results);
          resolve(res);
        })
        .catch(reject);
    });
  },
  FETCH_DATA_FOR_EXCEL({commit}, a) {
    return new Promise((resolve, reject) => {
      getExcel(a)
        .then((res) => {
          // commit("SET_ACTIVITY_DATA_FOR_EXCEL", res.data.results);
          resolve(res);
        })
        .catch(reject);
    });
  },
  FETCH_PERMISSIONS_CHILDREN({commit}, data) {
    return new Promise((resolve, reject) => {
      getPermissionListChildren(data.role_id, data.id, data.page_size).then(res => {
        if (data.name === 'first') {
          commit('SET_PERMISSION_FIRST_CHILDREN', res.data)
        }
        if (data.name === 'second') {
          commit('SET_PERMISSION_SECOND_CHILDREN', res.data)
        }
        if (data.name === 'third') {
          commit('SET_PERMISSION_THIRD_CHILDREN', res.data)
        }
        if (data.name === 'fourth') {
          commit('SET_PERMISSION_FOURTH_CHILDREN', res.data)
        }
        if (data.name === 'fifth') {
          commit('SET_PERMISSION_FIFTH_CHILDREN', res.data)
        }
        if (data.name === 'sixth') {
          commit('SET_PERMISSION_SIXTH_CHILDREN', res.data)
        }
        if (data.name === 'seven') {
          commit('SET_PERMISSION_SEVEN_CHILDREN', res.data)
        }
        if (data.name === 'eight') {
          commit('SET_PERMISSION_EIGHT_CHILDREN', res.data)
        }


        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchRoles({commit}, payload) {
    return new Promise((resolve, reject) => {
      getRolesApi(payload).then(res => {
        commit('SET_ROLES', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchUsersData({commit}, a) {
    return new Promise((resolve, reject) => {
      getUsersData(a)
        .then(res => {
          commit('SET_USERS', res.data.results)
          resolve(res)
        }).catch(err => {
        reject(err)
      })
    })
  },
  addUser({commit}, a) {
    return new Promise((resolve, reject) => {
      addUserData(a).then(res => {
        commit('ADD_USER', res.data.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  UPDATE_PERMISSIONS_LIST({commit}, a) {
    return new Promise((resolve, reject) => {
      EditPermission(a).then(res => {
        // commit('EDIT_PERMISSION_LIST', res.data.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  editUser({commit}, a) {
    return new Promise((resolve, reject) => {
      editUserData(a).then(res => {
        commit('EDIT_USER', res.data.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  deleteUser({commit}, a) {
    return new Promise((resolve, reject) => {
      deleteUserData(a).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  UPDATE_ROLE_STATUS(_, data) {
    return updateRole(data)
  },

  DELETE_ROLE(_, id) {
    return deleteRole(id)
  },

  CREATE_ROLE(_, data) {
    return addRole(data)
  },

  UPDATE_ROLE(_, data) {
    return updateRole2(data)
  },
}
//EDIT_USER
